RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    views.ToolbarEdit = Marionette.ItemView.extend({
        template: '#toolbarEditButtonTemplate',
        tagName: 'a',
        className: 'btn btn-default btn-xs toolbar-edit-btn',
        events: {
            'click': 'onClick'
        },
        onClick: function () {
            const me = this;
            me.triggerMethod('edit');
        }
    });

    views.ToolbarButton = Marionette.CompositeView.extend({
        template: '#toolbarButtonTemplate',

        triggers: {
            'click': {
                event: 'action',
                preventDefault: false,
                stopPropagation: false
            }
        },

        modelEvents: {
            'change:active': 'changeActive',
            'change:disabled': 'changeDisabled',
            'change:name': 'render'
        },

        onAction: function () {
            const me = this;
            const action = me.model.get('action') || me.getOption('action');

            if (action) {
                action.call(me);
            }
        },

        tagName: function () {

            const me = this;
            return (me.hasUrl() ? 'a' : 'button');
        },

        changeActive: function () {
            const me = this;
            me.$el.toggleClass('active', me.model.get('active'));
        },

        changeDisabled: function () {
            const me = this;
            me.$el.toggleClass('disabled', me.model.get('disabled'));
        },

        className: function () {

            const me = this;

            return _.compact([
                'btn',
                'x-toolbar-button',
                me.model.get('active') ? 'active' : '',
                me.model.get('disabled') ? 'disabled' : '',
                me.model.get('className') || me.getOption('btnClass')
            ]).join(' ');
        },

        attributes: function () {

            const me = this;
            const attributes = {};

            if (me.hasUrl()) {

                _.extend(attributes, {
                    href: me.getOption('btnLink')
                });
            }

            return attributes;
        },

        serializeData: function () {
            const me = this;

            const data = _.defaults(me.model.toJSON(), {
                icon: me.getOption('icon'),
                btnName: me.getOption('btnName'),
                linkIcon: !me.getOption('hideLinkIcon')
            });

            // TODO gross
            data.btnName = data.name || data.btnName;

            return data;
        },

        templateHelpers: function () {
            return {
                s: s
            };
        },

        hasUrl: function () {

            const me = this;
            return Boolean(me.getOption('btnLink'));
        }
    });

}, window.s);
